// extracted by mini-css-extract-plugin
module.exports = {"exam_rules_wrapper":"ExamRules_exam_rules_wrapper__GlkxV"};